import { Component, OnInit } from '@angular/core';
import { HeaderService } from './header.service';
import { CommonUtilitiesService } from '../common-utilities.service';
import { constants } from '../constants';
import * as $ from 'jquery';
import { LoginService } from '../login/login.service';
declare var $: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  listItemsMenu = null;
  isShowModal = false;
  modalTitle = "";
  modalContent = "";
  isNavOpen = false;
  dropDownlink: {isOpen: boolean, numButton: number} = {isOpen: false, numButton: -1};
  constructor(public LANG: CommonUtilitiesService, private headerService: HeaderService, private loginService: LoginService) { }
  /**
   * Description: Método que al cargar llama a su servcio y  genera el menu dinámicamente
   * Autor: Steven Sterling
   * @param N/A
   * @return N/A
   */
  ngOnInit() {
    if (this.listItemsMenu == null || this.listItemsMenu == '') {
      this.headerService.getMenuList({ "category": "PUBLICO" }).subscribe((dataInfo => {
        this.listItemsMenu = dataInfo['obj'];
        localStorage.setItem('menuList', JSON.stringify(this.listItemsMenu));
      }),
        (err) => {
          this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
          this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
          this.isShowModal = true;
        });
    }
  }

  hideModal() {
    this.modalTitle = "";
    this.modalContent = "";
    this.isShowModal = false;
  }

  /**
   * @author ejciro
   * @param newState 
   * Agrega o quita el background color de la barra de navegador  cuando se da click al icono de la hamburguesa
   */
  collapseOn(newState: boolean) {

    if (newState) {
      $('#menuHeader').removeClass('bg-blanco')
      $('#menuHeader').addClass('bg-violeta-open-nav fixed-top-nav')
      this.isNavOpen = newState;
    } else {
      $('#menuHeader').removeClass('fixed-top-nav');
      setTimeout(function () {
        $('#menuHeader').addClass('bg-blanco')
        $('#menuHeader').removeClass('bg-violeta-open-nav  ')
      }, 350);
      
      this.resetStyles();
      this.isNavOpen = newState;
    }
  };

  /**
   * @author ejciro
   * @param newState 
   * @param numButton 
   * Agrega o quita el background color completo cuando se da click a un menú con dropdown items
   */
  collapseDropDown(newState: boolean, numButton) {
    if(this.dropDownlink.numButton !== numButton && newState) {
      $('#ulDropDown').addClass('bg-100vh')
      this.dropDownlink.numButton = numButton;
      this.dropDownlink.isOpen = newState;
    } else if(this.dropDownlink.numButton === numButton && !newState) {
      $('#navbarDropdownMenuLink'+numButton).collapse('hide');
      this.resetStyles();
    }
  }

/**
   * @author ejciro
   * @param newState 
   * @param numButton 
   * Reinicia los estilos del menu collapsible
   */
  resetStyles(){    
    
    $('#ulDropDown').removeClass('bg-100vh')
    this.dropDownlink.numButton = -1;
    this.dropDownlink.isOpen = false;
  }

  //Cierra todo el menú cuando se cambia de pantalla
  changePage(url:string = ''){
    $('#menuHeader').removeClass('fixed-top-nav');
    setTimeout(function () {
      $('#menuHeader').addClass('bg-blanco')
      $('#menuHeader').removeClass('bg-violeta-open-nav')
    }, 350);
    this.isNavOpen = false;
    $('#navbarNavDropdown').collapse('hide');
    this.resetStyles();
    this.loginService.setUrlToRedirect(url);
  }
}
